import { Flex, useCheckboxGroup } from "@chakra-ui/react";
import { ITags } from "src/api/server/extended-search";
import { CheckboxList } from "src/components/pages/search/components/tags-filter/components/checkbox-list";
import { IChangeFilterTag } from "src/components/pages/search/components/types";
import { ISearch } from "src/components/pages/search/search.types";
import { handleTags } from "src/components/pages/search/store/actions";
import { EnumTagColor } from "src/types/common-enum";

interface ITagsList extends ISearch {
    tags: ITags;
    onClick?: (isChecked: boolean, value: string) => void;
}

export const TagsList = ({ tags, onSearch, onClick }: ITagsList) => {
    const { getCheckboxProps } = useCheckboxGroup();

    const { basics, tradings, rewards, investmentHorizon, investmentRegion } = tags;

    const tagFilters = [
        {
            filterTags: rewards.tags,
            color: EnumTagColor.Green,
        },
        {
            filterTags: tradings.tags,
            color: EnumTagColor.Lilac,
        },
        {
            filterTags: investmentHorizon.tags,
            color: EnumTagColor.Blue,
        },
        {
            filterTags: investmentRegion.tags,
            color: EnumTagColor.Orange,
        },
        {
            filterTags: basics.tags,
            color: EnumTagColor.Gray,
        },
    ];

    const onTagChange = ({ isChecked, value, isPopular }: IChangeFilterTag) => {
        onClick?.(isChecked, value);
        handleTags({ isChecked, value, isPopular, tagsData: tags, onSearch });
    };

    return (
        <Flex flexWrap="wrap" gap={2}>
            {tagFilters.map(filter => (
                <CheckboxList
                    key={filter.color}
                    filterTags={filter.filterTags}
                    color={filter.color}
                    getCheckboxProps={getCheckboxProps}
                    onChange={onTagChange}
                />
            ))}
        </Flex>
    );
};
